import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';

/* Rxjs */
import { Observable, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

/* Services */
import { AuthService } from '../services/auth.service';
import { environment } from '@env/environment';

@Injectable()
export class AuthApiInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith(environment.AURORA_S3)) {
      // bypass API auth for S3 access
      return next.handle(req);
    }

    return this.authService.getAccessToken().pipe(
      switchMap(jwtToken => {
        const authReq = req.clone({
          headers: req.headers.set('Authorization', `Bearer ${jwtToken}`)
        });
        return next.handle(authReq).pipe(
          map(res => {
            if (res instanceof HttpResponse) {
              this.checkApiStatusResponse(res.status);
            }
            return res;
          }),
          catchError(err => {
            if (err instanceof HttpErrorResponse) {
              if (err.error instanceof ErrorEvent) {
                // console.error('Error Event');
              } else {
                this.checkApiStatusResponse(err.status);
              }
            } else {
              // console.error("some thing else happened");
            }
            return throwError(() => new Error(err.statusText));
          })
        );
      })
    );
  }

  /**
   * @description Check status of api response
   * @private
   * @param {number} status
   */
  private checkApiStatusResponse(status: number): void {
    switch (status) {
      case 401:
        this.authService.signOut();
        break;
      case 403:
        this.authService.signOut();
        break;
      default:
        break;
    }
  }
}
